var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 73,
    stroke: "#DC9870",
    strokeWidth: 3.08451
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0703 81.748L59.1728 102.851L111.929 50.0942",
    stroke: "#DC9870",
    strokeWidth: 3.08451,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIconLarge);
export default __webpack_public_path__ + "static/media/Done Icon Large.e7ae8e0f2505c3bb908d4ab9a1970cd1.svg";
export { ForwardRef as ReactComponent };